import { WarningType } from 'api';
import { createEnumOptions } from 'const/createEnumOptions';
import { getWarningTypeName } from './warningTypeHelpers';

export const WARNING_TYPE_OPTIONS = createEnumOptions(WarningType, getWarningTypeName);
